module.exports = __webpack_public_path__ + "static/media/19.79cda05c.jpg";